import { Component, Inject } from '@angular/core';
import { FormService } from "../../services/form.service";
import { TrackingService } from "../../services/tracking.service";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup } from "@angular/forms";

@Component({
	selector: 'app-consent-movers-modal',
	templateUrl: './consent-movers-modal.component.html',
	styleUrls: ['./consent-movers-modal.component.scss']
})
export class ConsentMoversModalComponent {
	public modalForm: UntypedFormGroup;
	public modalMovers: UntypedFormArray;
	readonly maxSelections: number = 5;

	constructor(
		public formService: FormService,
		private trackingService: TrackingService,
		private dialogRef: MatDialogRef<ConsentMoversModalComponent>,
		@Inject(MAT_DIALOG_DATA) data: { moverValues: any[] }
	) {
		// Create a new FormArray for the modal
		this.modalMovers = new UntypedFormArray([]);
		
		// Create form controls from the values.
		// Rebuilt from the value's own keys, so any field FormService.buildMoverGroup()
		// adds shows up here without a second list to keep in sync.
		data.moverValues.forEach(value => {

			const controls: { [key: string]: UntypedFormControl } = {};

			Object.keys( value ).forEach( key => {

				controls[key] = new UntypedFormControl( value[key] );
			} );

			this.modalMovers.push( new UntypedFormGroup( controls ) );
		});

		// Create a separate FormGroup for the modal
		this.modalForm = new UntypedFormGroup({
			movers: this.modalMovers
		});
	}

	public getSelectedCount(): number {
		return this.modalMovers.controls.filter(control => control.get('checkbox')?.value).length;
	}

	confirm() {
		// Log modal movers before sync
		const modalMoversTable = this.modalMovers.controls.map((control, index) => ({
			index,
			id: control.get('_id')?.value,
			name: control.get('_name')?.value,
			selected: control.get('checkbox')?.value ? '✓' : '✗'
		}));
		console.log('Modal Movers before sync:');
		console.table(modalMoversTable);

		// Get the consentMovers form group from the form service
		const consentMovers = this.formService.mainForm.get('consentMovers') as UntypedFormGroup;
		const moversArray = consentMovers.get('movers') as UntypedFormArray;

		// Log original movers before sync
		const originalMoversTable = moversArray.controls.map((control, index) => ({
			index,
			id: control.get('_id')?.value,
			name: control.get('_name')?.value,
			selected: control.get('checkbox')?.value ? '✓' : '✗'
		}));
		console.log('Original Movers before sync:');
		console.table(originalMoversTable);

		// Update each mover in the original form with the modal's values
		this.modalMovers.controls.forEach(modalControl => {
			const modalId = modalControl.get('_id')?.value;
			const modalSelected = modalControl.get('checkbox')?.value;

			// Find and update the corresponding mover in the original form
			for (let i = 0; i < moversArray.controls.length; i++) {
				const originalControl = moversArray.controls[i];
				if (originalControl.get('_id')?.value === modalId) {
					// Use patchValue to update the control
					originalControl.patchValue({
						checkbox: modalSelected
					}, { emitEvent: false });
					break;
				}
			}
		});

		// Log original movers after sync
		const originalMoversAfterTable = moversArray.controls.map((control, index) => ({
			index,
			id: control.get('_id')?.value,
			name: control.get('_name')?.value,
			selected: control.get('checkbox')?.value ? '✓' : '✗'
		}));
		console.log('Original Movers after sync:');
		console.table(originalMoversAfterTable);

		this.formService.trackEventWithContext( 'Prematch - Confirm modal', 'consentMovers', {
			selected_count: this.getSelectedCount()
		} );
		this.dialogRef.close(true);
	}

	cancel() {

		this.dialogRef.close( false );
	}
}
